import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=074ab8ec&scoped=true&"
import script from "./Detect.vue?vue&type=script&lang=js&"
export * from "./Detect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ab8ec",
  null
  
)

export default component.exports